<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <dev-bpbj-warehousing-record-form
      :disabled="disableSubmit"
      :triggerId="triggerId"
      @ok="submitCallback"
      ref="realForm"
    ></dev-bpbj-warehousing-record-form>
  </j-modal>
</template>

<script>

  import DevBpbjWarehousingRecordForm from './DevBpbjWarehousingRecordForm'
  export default {
    name: 'DevBpbjWarehousingRecordModal',
    components: {
      DevBpbjWarehousingRecordForm
    },
    props: {
      triggerId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        title: '',
        width: 1300,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk (v) {
        this.$refs.realForm.submitForm()
      },
      submitCallback (v) {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
